const cookieTypes = [
  {
    id: 'essential',
    name: 'Essential',
    description:
      '<p>These cookies are necessary for the website to function properly and cannot be switched off. They help with things like logging in and setting your privacy preferences.</p>',
    required: true
  },
  {
    id: 'analytics',
    name: 'Analytics',
    description:
      '<p>These cookies help us improve the site by tracking which pages are most popular and how visitors move around the site.</p>',
    required: false,
    onAccept: async () => {
      const { resetAnalyticsOnConsentChange } = await import(
        '../firebase/ga_analytics'
      );
      await resetAnalyticsOnConsentChange();
    },
    onReject: async () => {
      const { resetAnalyticsOnConsentChange } = await import(
        '../firebase/ga_analytics'
      );
      await resetAnalyticsOnConsentChange();
    }
  }
];

export const getOrCreateSilktideBannerManager = async () => {
  if (window.silktideCookieBannerManager) {
    return window.silktideCookieBannerManager;
  }

  const { default: SilktideCookieBanner } = await import(
    './silktide-consent-manager'
  );

  const manager = new SilktideCookieBanner({ cookieTypes });
  window.silktideCookieBannerManager = manager;
  return manager;
};
